module.exports = __webpack_public_path__ + "img/Temperus_round.414405bf.png";